var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    d: "m8.143 12.357 4.714-4.714M6.376 9.411l-1.179 1.178a3.334 3.334 0 1 0 4.715 4.714l1.177-1.178M9.91 5.875l1.178-1.179a3.333 3.333 0 1 1 4.714 4.715l-1.178 1.178"
  })));
};
export default SvgLink;